import axios from 'axios';

export interface ChangeRequest {
  id: string;
  documentId: string;
  documentTitle: string;
  documentNumber: string;
  changeReason: string;
  approverId: string;
  approverName: string;
  requestedByUserId: string;
  requestedByName: string;
  requestedAt: string;
  status: 'pending' | 'approved' | 'rejected';
  approverComment?: string;
  resolvedAt?: string;
}

const BASE_API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5180/api';
const API_URL = `${BASE_API_URL}/ChangeRequest`;

function authHeaders() {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export async function createChangeRequest(
  data: Omit<ChangeRequest, 'id' | 'requestedAt' | 'status'>
): Promise<ChangeRequest> {
  const response = await axios.post<ChangeRequest>(API_URL, data, {
    headers: authHeaders(),
  });
  return response.data;
}

export async function getAllChangeRequests(): Promise<ChangeRequest[]> {
  const response = await axios.get<ChangeRequest[]>(API_URL, {
    headers: authHeaders(),
  });
  return response.data;
}

export async function getChangeRequestById(id: string): Promise<ChangeRequest> {
  const response = await axios.get<ChangeRequest>(`${API_URL}/${id}`, {
    headers: authHeaders(),
  });
  return response.data;
}

export async function approveChangeRequest(id: string, comment?: string): Promise<ChangeRequest> {
  const response = await axios.post<ChangeRequest>(
    `${API_URL}/${id}/approve`,
    { comment: comment ?? '' },
    { headers: authHeaders() }
  );
  return response.data;
}

export async function rejectChangeRequest(id: string, comment?: string): Promise<ChangeRequest> {
  const response = await axios.post<ChangeRequest>(
    `${API_URL}/${id}/reject`,
    { comment: comment ?? '' },
    { headers: authHeaders() }
  );
  return response.data;
}
